import { useEffect, useRef } from "react";
import { DetalleEntradaSerieForm } from "./DetalleEntradaSerieForm";
import { Form } from "antd";
import { DetalleEntradaLoteForm } from "./DetalleEntradaLoteForm";
import dayjs from "dayjs";

import { ButtonUi, FormItemHiddenUi, Modal, FormUi } from "../../../ui";
import { TipoButtonConstants } from "../../../../types/typesConstants";

const initialValues = {
  item: null,
  series: [],
  lotes: [],
  manejalotes: false,
  manejaseries: false,
};
// reset form fields when modal is form, closed
const useResetFormOnCloseModal = ({ form, open }) => {
  const prevOpenRef = useRef();
  useEffect(() => {
    prevOpenRef.current = open;
  }, [open]);
  const prevOpen = prevOpenRef.current;
  useEffect(() => {
    if (!open && prevOpen) {
      form.resetFields();
    }
  }, [form, prevOpen, open]);
};

export const DetalleSeriesLotesModal = ({
  manejalotes,
  manejaseries,
  cantidad,
  series,
  lotes,
  item,
  open,
  onCancel,
}) => {
  const [form] = Form.useForm();
  useResetFormOnCloseModal({ form, open });
  useEffect(() => {
    if (open) {
      if (cantidad > 0) {
        if (manejaseries) {
          const itemdefault = {
            numero_serie: "",
            fecha_fabricacion: dayjs(),
          };
          if (series?.length < 1) {
            const count_new_items = cantidad - series?.length || 0;
            for (let i = 0; i < count_new_items; i++) {
              series.push(itemdefault);
            }
          } else
            series = series?.map((x) => ({
              ...x,
              fecha_fabricacion: dayjs(x?.fecha_fabricacion),
            }));
          form.setFieldsValue({ series, item });
        } else if (manejalotes) {
          const item_lote = {
            numero_lote: null,
            cantidad: null,
            fecha_fabricacion: dayjs(),
            fecha_vencimiento: dayjs(),
          };
          if (lotes?.length < 1) {
            lotes.push(item_lote);
          } else {
            lotes = lotes?.map((x) => ({
              ...x,
              fecha_fabricacion: dayjs(x?.fecha_fabricacion),
              fecha_vencimiento: dayjs(x?.fecha_vencimiento),
            }));
          }
          form.setFieldsValue({ lotes, item });
        }
      }
    }
  }, [cantidad, open]);

  const handleSave = () => {
    onCancel();
  };

  return (
    <Modal
      title="Detalle producto por lote/serie"
      centered
      maskClosable={false}
      destroyOnHidden
      open={open}
      onCancel={onCancel}
      width="60%"
      footer={[
        <ButtonUi
          key="back"
          typeUi={TipoButtonConstants.Cancelar}
          onClick={onCancel}
        />,
        <ButtonUi
          key="submit"
          typeUi={TipoButtonConstants.Guardar}
          htmlType="submit"
          form="FormDetalleSerieLote"
        />,
      ]}
    >
      <FormUi
        name="FormDetalleSerieLote"
        form={form}
        layout="vertical"
        autoComplete="off"
        initialValues={initialValues}
        handleSubmit={handleSave}
      >
        <FormItemHiddenUi name="item" />
        {manejalotes && <DetalleEntradaLoteForm cantidad={cantidad} />}
        {manejaseries && (
          <DetalleEntradaSerieForm cantidad={cantidad} openModal={open} />
        )}
      </FormUi>
    </Modal>
  );
};
